<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="dependent-dialog-title" [formGroup]="form">

  <!-- Banner error -->
  <div class="info-banner error-banner" role="alert" *ngIf="showErrorBanner">
    <div class="info-banner-icon">
      <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
    </div>
    <div class="info-banner-text">
      <span>Por favor, completa todos los campos obligatorios para continuar.</span>
    </div>
  </div>

  <h2 id="dependent-dialog-title" class="dialog-title">
    <img src="assets/agricola/header-user.svg" alt="" aria-hidden="true" class="title-icon" />
    {{ data.mode === 'edit' ? 'Editar dependiente' : 'Añadir dependiente' }}
  </h2>
  <p class="subtitle">Ingresa la información requerida para agregar un dependiente.</p>

  <div class="dialog-grid">

    <div class="field">
      <app-sis-field
        label="*Nombre(s)"
        [maxlength]="nameMaxLength"
        [error]="nameError('first_name', 'nombre')"
        formControlName="first_name">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-field
        label="Segundo nombre"
        [maxlength]="nameMaxLength"
        [error]="nameError('middle_name', 'segundo nombre')"
        formControlName="middle_name">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-field
        label="*Primer apellido"
        [maxlength]="nameMaxLength"
        [error]="nameError('last_name', 'primer apellido')"
        formControlName="last_name">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-field
        label="Segundo apellido"
        [maxlength]="nameMaxLength"
        [error]="nameError('last_name_2', 'segundo apellido')"
        formControlName="last_name_2">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-select
        label="*Género"
        placeholder="Selecciona género"
        [options]="genderOptions"
        [error]="form.get('gender')?.invalid && form.get('gender')?.touched ? 'Selecciona género.' : ''"
        formControlName="gender">
      </app-sis-select>
    </div>

    <div class="field">
      <app-sis-select
        label="*Parentesco"
        placeholder="Selecciona parentesco"
        [options]="relationshipOptions"
        [loading]="relationshipLoading"
        [loadedKey]="relationshipLoadedKey"
        loadedMessage="Catálogo de parentescos cargado"
        [loadFailed]="relationshipLoadFailed"
        (retryLoad)="retryRelationship()"
        [caption]="relationshipCaption"
        [helper]="relationshipLoading ? 'Cargando parentescos...' : ''"
        [error]="relationshipError"
        formControlName="relationship">
      </app-sis-select>
    </div>

    <!-- La fecha va antes que la identificación: de ella depende si el
         dependiente captura documento (mayor) o se le genera (menor). -->
    <div class="field">
      <app-sis-date-field
        label="*Fecha de nacimiento"
        [max]="maxBirthday"
        [error]="birthdayError"
        formControlName="birthday">
      </app-sis-date-field>
    </div>

    <div class="field" *ngIf="showIdentificationFields">
      <app-sis-select
        label="*Tipo de identificación"
        placeholder="Selecciona tipo"
        [options]="identificationTypeOptions"
        [error]="form.get('identification_type')?.invalid && form.get('identification_type')?.touched ? 'Selecciona tipo de identificación.' : ''"
        formControlName="identification_type">
      </app-sis-select>
    </div>

    <div class="field" *ngIf="showIdentificationFields">
      <app-sis-field
        label="*Número de identificación"
        [maxlength]="identificationMaxLength"
        [error]="identificationError"
        formControlName="identification_id">
      </app-sis-field>
    </div>

    <div class="field full" *ngIf="isMinor">
      <p class="minor-note">
        El dependiente es menor de edad: su número de identificación se genera automáticamente
        a partir de la identificación del titular.
      </p>
    </div>

  </div>

  <div class="dialog-actions">
    <app-sis-button variant="secondary" (pressed)="cancel()">CANCELAR</app-sis-button>
    <app-sis-button (pressed)="save()">GUARDAR</app-sis-button>
  </div>
</div>
